import { observer } from 'mobx-react';
import React from 'react';
import { Neo } from '@singularsystems/neo-react';
import CurrencyComponentVM from './CurrencyComponentVM';

interface ICurrencyComponentProps {
    viewModel: CurrencyComponentVM;
    label: string;
}

@observer
export default class CurrencyComponent extends React.Component<ICurrencyComponentProps> {
    public render() {
        var viewModel = this.props.viewModel;

        return (
            <>
                <>
                    <Neo.FormGroup
                        label={this.props.label}
                        bind={viewModel.selectedCurrency.meta.staticCurrencyId}
                        readOnly={viewModel.isReadOnly}
                        select={{ items: viewModel.staticCurrencyLookupList, displayMember: "currencyCode", valueMember: "staticCurrencyId", allowNulls: true }}
                    />
                </>
            </>
        )
    }
}